import axios from "axios";
import { URL_BASE } from "../config/url-server";

const clientId = localStorage.getItem("client")
const accessToken = localStorage.getItem("token")

export const operatorLotReport = async (page,limit,startDate, endDate,farmId,sectionId,lotId,userId) => {
  const params = {startDate,endDate,farmId,lotId,page,limit ,sectionId,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "yield-report/operator-lot-report",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};




export const operatorLotExcel = async (startDate, endDate,farmId,sectionId,lotId,userId) => {
  console.log("excel corregido")
  const params = {startDate,endDate,farmId,lotId,clientId,sectionId,userId};
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}` }, params, responseType: 'blob' };
  try {
    const response = await axios.get(URL_BASE + "yield-report/operator-lot-excel", config);
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      return response.data; 
    } else {   
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || "Error desconocido al generar el reporte.");
    }
  } catch (error) {
    return { error: error.message };
  }
};

export const detailedReport = async (page,limit,startDate, endDate,farmId,sectionId,lotId,userId) => {
  const params = {startDate,endDate,farmId,lotId,page,limit ,sectionId,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "yield-report/detailed-report",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};


export const detailedExcel = async (startDate, endDate,farmId,sectionId,lotId,userId) => {
  console.log("excel corregido")
  const params = {startDate,endDate,farmId,lotId,clientId,sectionId,userId};
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}` }, params, responseType: 'blob' };
  try {
    const response = await axios.get(URL_BASE + "yield-report/detailed-excel", config);
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      return response.data; 
    } else {   
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || "Error desconocido al generar el reporte.");
    }
  } catch (error) {
    return { error: error.message };
  }
};



export default {
  operatorLotReport,
  operatorLotExcel,
  detailedReport,
  detailedExcel
};
